import RfiReadOnlyAttachments from "components/RfiReadOnlyAttachments";
import { useAppSelector } from "hooks/redux";
import { selectRfi } from "store/rfiSlice";
import { selectVendorResponse } from "store/vendorResponseSlice";
import { vendorNavPages } from "./VendorNav";

interface IRfiVendorAllProps {
  user?: any;
  setSelectedPage?: any;
}

const VendorReadOnlyAttachments = (props: IRfiVendorAllProps) => {
  // Hooks
  const rfi = useAppSelector(selectRfi);
  const vendorResponse = useAppSelector(selectVendorResponse);

  // Render
  return (
    <>
      <div className="rfi-content">
        <h1>RFI Attachments</h1>

        <RfiReadOnlyAttachments attachments={rfi.attachments ?? []} />

        {props.user &&
        (!props.user.isAuthenticated ||
          (vendorResponse.vendorResponse?.vendorResponseId ?? 0) === 0) ? (
          <div className="mt-5">
            <button
              className="btn btn-primary m-1"
              role="button"
              onClick={() =>
                props.setSelectedPage(vendorNavPages.UNAUTH_DETAILS)
              }
            >
              <i className="fa-solid fa-chevron-left"></i>Details
            </button>
            <button
              className="btn btn-primary m-1"
              role="button"
              onClick={() =>
                props.setSelectedPage(vendorNavPages.UNAUTH_QUESTIONNAIRE)
              }
            >
              Questionnaire <i className="fa-solid fa-chevron-right"></i>
            </button>
          </div>
        ) : (
          <div>
            <button
              className="btn btn-primary m-1"
              role="button"
              onClick={() => props.setSelectedPage(vendorNavPages.AUTH_DETAILS)}
            >
              <i className="fa-solid fa-chevron-left"></i> Details
            </button>
            <button
              className="btn btn-primary m-1"
              role="button"
              onClick={() => props.setSelectedPage(vendorNavPages.QA)}
            >
              Q&A <i className="fa-solid fa-chevron-right"></i>
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default VendorReadOnlyAttachments;
